<script lang="ts">
  // Icon + sentence — the mockup's empty-state pattern for tables/lists.
  import type { Component } from 'svelte';

  const {
    icon,
    title,
    body
  }: { icon?: Component<{ class?: string }>; title: string; body?: string } = $props();
</script>

<div class="flex flex-col items-center gap-2 px-6 py-10 text-center">
  {#if icon}
    {@const Icon = icon}
    <Icon class="h-6 w-6 text-dark-gray" />
  {/if}
  <div>
    <div class="tym-empty-title">{title}</div>
    {#if body}
      <div class="text-[12.5px] text-dark-gray">{body}</div>
    {/if}
  </div>
</div>
